// Shared by the receipt layout editor and its preview. The layout itself (and its default) comes
// from the API — see camel-step-ecommerce-api/src/util/receiptLayout.js — so this file only holds
// what the admin UI needs to show it: names, the fixed option lists, and which rows are locked.

export const SIZE_OPTIONS = [
    { value: "xs", label: "Extra small" },
    { value: "sm", label: "Small" },
    { value: "md", label: "Medium" },
    { value: "lg", label: "Large" },
    { value: "xl", label: "Extra large" },
];

// Logo and QR only: three steps, because each engine maps them to its own units and neither can go
// far — a logo wider than 180 dots does not print on a Sunmi, and a small QR stops scanning.
export const BARE_SIZE_OPTIONS = [
    { value: "sm", label: "Small" },
    { value: "md", label: "Medium" },
    { value: "lg", label: "Large" },
];

// Mirrors signage src/config/printers.ts, for the preview.
export const LOGO_WIDTH_BY_SIZE = { sm: 96, md: 140, lg: 180 };
export const QR_MODULE_BY_SIZE = { sm: 3, md: 4, lg: 6 };

export const ALIGN_OPTIONS = [
    { value: "left", label: "Left" },
    { value: "center", label: "Center" },
    { value: "right", label: "Right" },
];

export const ROW_LABELS = {
    logo: "Receipt logo",
    brandName: "Company name",
    arabicName: "Arabic name",
    invoiceTitle: "Invoice title",
    vatNumber: "VAT number",
    crNumber: "CR number",
    address: "Address",
    branchName: "Branch name",
    branchAddress: "Branch address",
    branchPhone: "Branch phone",
    phone: "Phone",
    website: "Website",
    email: "Email",
    zatcaQr: "ZATCA QR code",
    text: "Custom text",
};

// Required on a simplified tax invoice. The API refuses a layout that hides them.
export const LOCKED_KEYS = ["brandName", "invoiceTitle", "vatNumber", "zatcaQr"];

// Rows with nothing to style — only whether they show, and where.
export const BARE_KEYS = ["logo", "zatcaQr"];

export const MAX_TEXT_ROWS = 5;
export const MAX_TEXT_LENGTH = 120;

// The printed labels, exactly as the screen prints them (signage src/utils/print/receiptLabels.ts).
export const LABELS = {
    taxInvoiceEn: "Simplified Tax Invoice",
    taxInvoiceAr: "فاتورة ضريبية مبسطة",
    orderReceiptEn: "Order Receipt",
    orderReceiptAr: "إيصال الطلب",
    vatNumber: "VAT No. الرقم الضريبي",
    crNumber: "CR No. السجل التجاري",
    branch: "Branch الفرع",
    orderRef: "Order Ref رقم الطلب",
    orderType: "Order Type نوع الطلب",
    amount: "Amount المجموع",
    vat: "VAT (15%) ضريبة القيمة المضافة",
    total: "Total الإجمالي",
    addOns: "Add Ons الإضافات",
};
